import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import FeaturedProducts from '../components/FeaturedProducts';
import HeroSection from '../components/HeroSection';
import SolutionsPreview from '../components/SolutionsPreview';
import StatsTicker from '../components/StatsTicker';
import TrustBar from '../components/TrustBar';
import { whyReasons } from '../data/siteData';
import './Home.css';

const Home = () => (
  <>
    <HeroSection />
    <StatsTicker />
    <FeaturedProducts />
    <SolutionsPreview />
    <TrustBar />

    <section className="section home-why" id="why-us">
      <div className="container">
        <div className="section-header">
          <div>
            <p className="eyebrow">Why NovaCareLinens</p>
            <h2 className="section-title">The linen partner built around healthcare procurement.</h2>
          </div>
          <p className="section-sub">
            We combine the compliance support of a large supplier with the
            speed, flexibility, and personal service of a focused healthcare
            textile provider.
          </p>
        </div>

        <div className="home-why-grid">
          {whyReasons.slice(0, 4).map(({ title, desc, Icon }, index) => (
            <article className="home-why-card stagger-card" key={title} style={{ '--delay': `${index * 80}ms` }}>
              <span className="icon-circle tone-amber">
                <Icon size={22} strokeWidth={1.8} aria-hidden="true" />
              </span>
              <h3>{title}</h3>
              <p>{desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>

    <section className="section home-cta">
      <div className="container home-cta-card surface-card">
        <div>
          <p className="eyebrow">Quote request</p>
          <h2>Ready to price a compliant linen program?</h2>
          <p>
            Tell us your facility type, monthly volume, and priority products.
            A procurement specialist will respond within 24 business hours.
          </p>
        </div>
        <Link className="btn-primary" to="/contact">
          Start quote <ArrowRight size={18} aria-hidden="true" />
        </Link>
      </div>
    </section>
  </>
);

export default Home;
